/**
 * 知识广场访问状态
 */
export enum SQUARE_VISIT_STATUS {
    /**
     * 第一次进入知识广场跳转到知识库创建页面的编辑状态。
     */
    FIRST_EDIT_STATUS = 'FIRST_EDIT_STATUS',

    /**
     * 第一次进入知识广场跳转到知识库创建页面的预览状态。
     */
    FIRST_PREVIEW_STATUS = 'FIRST_PREVIEW_STATUS',
}

export const PUBLISH_STATUS = {
    bothUnPublish: '0', // 未发布到知识广场 & 未发布到个人主页
    onlyPublishToPerson: '2', // 发布到个人主页  & 未发布到知识广场
    bothPublishToSquareAndPersonalPage: '1', // 发布到知识广场 & 发布到个人主页
} as const;

export const ARTICLE_STATUS = {
    AUDITING: 'AUDITING', // 知识广场审核中
    FAILED: 'FAILED', // 知识广场审核失败
    RECOMMENDING: 'RECOMMENDING', // 知识广场推荐中
    NORMAL: 'NORMAL', // 知识广场
    DELETED: 'DELETED',
};


